import React from "react"
import { Pie } from "@ant-design/plots"
import { connect } from "react-redux"
import { AuthActions } from "redux-store/models"
import { Card, Icon } from "antd"
import { baseUrlImg } from "../../../config/api"

const DonutStatistiche = (props) => {
  const { stats, images } = props

  const totalAll =
    stats && Object.values(stats).reduce((sum, s) => sum + (s.total_amount || 0), 0)


  let transformedData =
    stats &&
    Object.entries(stats)
      .map(([serviceName, values]) => ({
        type: serviceName,
        value: totalAll > 0 ? (values.total_amount / totalAll) * 100 : 0,
        amount: values.total_amount || 0,
        icon: images?.find((img) => img.id === values.company?.icon_id), 
      }))
      .sort((a, b) => b.amount - a.amount) 
      .slice(0, 5) 

  const config = {
    appendPadding: 10,
    data: transformedData || [],
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.7,
    label: false,
    tooltip: {
      customContent: (title, items) => {
        return (
          <div style={{ padding: "6px 8px" }}>
            {items?.map((item, idx) => {
              const icon = transformedData.find((d) => d.type === item.name)?.icon
              const value = Number(item.value) || 0 
              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "4px",
                  }}
                >
                  {icon && (
                    <img
                      src={`${baseUrlImg}/${icon.path_slug}`}
                      alt={icon.name}
                      style={{ height: "20px", width: "20px" }}
                    />
                  )}
                  <span>
                    {item.name}: {value.toFixed(2)}%
                  </span>
                </div>
              )
            })}
          </div>
        )
      },
    },

    interactions: [{ type: "element-selected" }, { type: "element-active" }],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "22px",
        },
        content: `Totale: €${totalAll.toFixed(2)}`,
      },
    },
  }

  return (
    <div className="donut-statistiche">
      <Card
        title="Percentuali sul totale"
        bordered={false}
        extra={<Icon type="ellipsis" key="ellipsis" />}
      >
        <Pie {...config} />
      </Card>
    </div>
  )
}

const mapStateToProps = (state) => ({
  stats: state.main.stats,
  images: state.main.images,
})

export default connect(mapStateToProps, AuthActions)(DonutStatistiche)
